import { REACT_APP_API_URL } from "../../setup/config";
import axios, { handleApiError } from "../axios"

export const getCompanyTags = async(data) => {
    try{
        const response = await axios.post(`${REACT_APP_API_URL}/company-tags`, data)
        const result = await response.data;
        return result
    }catch(error){
        return handleApiError(error)
    }
}